import { filter } from 'lodash';

import { DeviceOS } from 'enums';
import { Deeplink } from 'types';

export const getMatchingDeeplinks = ({
  deeplinks,
  customerBank,
  deviceOS,
}: {
  deeplinks: Deeplink[] | undefined;
  customerBank?: string;
  deviceOS: DeviceOS | '';
}): Deeplink[] =>
  filter(
    deeplinks,
    (deeplink) =>
      !!deeplink.url &&
      (!customerBank || deeplink.customerBank === customerBank) &&
      (deviceOS === DeviceOS.Desktop ||
        !deeplink.deviceOs ||
        deeplink.deviceOs === deviceOS),
  );
